import { QueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/features/auth/store';

export const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, retry: 1, refetchOnWindowFocus: false } },
});

// Cancel background reads and remove private data on logout/account changes.
useAuthStore.subscribe((state, previous) => {
  if (state.token !== previous.token || state.user?.id !== previous.user?.id) queryClient.clear();
});
